@if (isLoading) {
<div class="flex flex-column align-items-center justify-content-center w-full h-21rem">
    <i class="pi pi-spin pi-spinner" style="font-size: 2.5rem"></i>
    <h1 style="font-size: 2.5rem">Loading Details</h1>
</div>
}
@else if (deal == null) {
<div class="flex flex-column align-items-center justify-content-center w-full h-21rem">
    <h1><span style="font-size: 2.5rem">:(</span></h1>
    <h1 style="font-size: 2.5rem">Not Found</h1>
</div>
}
@else {
<div class="deal-view">
    <div class="deal-view__header">
        <h1 class="deal-view__title">{{ deal.title }} - {{ deal.crmid }}
            <span *ngIf="deal.isManuall" class="opacity-70 font-italic">(Manuall Collection)</span>
            <a target="_blank" [href]="'https://i-host.pipedrive.com/deal/' + deal.crmid" class="ml-2 cursor-pointer"
                title="Pipedrive"><i class="pi pi-link"></i></a>
        </h1>
    </div>
</div>

<p-toolbar styleClass="mb-4 gap-2 top-action-bar" [style]="{'z-index': '2'}">
    <ng-template pTemplate="left">
        <div class="flex align-items-center gap-2">
        </div>
    </ng-template>

    <ng-template pTemplate="right">
        <p-button *ngIf="deal.type == 1" severity="info" label="Refresh Data" icon="pi pi-download" class="mr-2"
            (onClick)="updateDealDataForRenewal()" />
        <p-button *ngIf="deal.type == 1" severity="primary" label="Preview Renewal PDF" icon="pi pi-file" class="mr-2"
            (onClick)="downloadPdf()" />
    </ng-template>
</p-toolbar>

<div class="grid m-0">
    <div class="col-12 xl:col-8">
        <p class="mx-1 my-3">
            <p-panel>
                <ng-template #header>
                    <div class="flex items-center justify-content-between w-full">
                        <p class="m-0 font-bold">Details</p>
                        <p class="m-0">
                            <p-tag severity="success" [value]="deal.type| dealType" />
                        </p>
                    </div>
                </ng-template>
                <div class="grid">
                    <div class="flex flex-column gap-2 col-12">
                        <label>Title</label>
                        <input pInputText disabled="disabled" [ngModel]="deal.title" />
                    </div>
                    <div class="flex flex-column gap-2 col-12 lg:col-6">
                        <label>Name</label>
                        <input pInputText disabled="disabled" [ngModel]="deal.customer.name" />
                    </div>
                    <div class="flex flex-column gap-2 col-12 lg:col-6">
                        <label>Legal Name</label>
                        <input pInputText disabled="disabled" [ngModel]="deal.customer.legalName" />
                    </div>
                    <div class="flex flex-column gap-2 col-12 lg:col-6">
                        <label>VAT</label>
                        <input pInputText disabled="disabled" [ngModel]="deal.customer.vatNumber" />
                    </div>
                    <div class="flex flex-column gap-2 col-12 lg:col-6">
                        <label>Country</label>
                        <input pInputText disabled="disabled" [ngModel]="deal.customer.country" />
                    </div>
                </div>
            </p-panel>
        </p>

        <p class="mx-1 my-3">
            <p-panel header="Payments">
                <p class="m-0">
                    <p-table [value]="deal.payments" [tableStyle]="{ 'min-width': '50rem' }">
                        <ng-template #header>
                            <tr>
                                <th></th>
                                <th>Amount</th>
                                <th>Failed Attempts</th>
                                <th>Due date</th>
                                <th>Payment date</th>
                                <th>Method</th>
                                <th>Done</th>
                                <th>Processing</th>
                                <th>Error</th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-payment>
                            <tr>
                                <td>{{ payment.index }}</td>
                                <td>{{ payment.amount | number: '2.2-2' }}</td>
                                <td>{{ payment.failedAttempts }}</td>
                                <td>
                                    <div
                                        style="display: flex; align-items: center; gap: 0.5rem; justify-content: space-between;">
                                        <span>{{ payment.dueDate | date: 'dd/MM/yyyy' }}</span>
                                        <i *ngIf="payment.isProcessing != true && payment.done != true && payment.dueDate != null"
                                            class="pi pi-pencil" style="cursor: pointer;"
                                            (click)="showModifyPaymentModal(payment)" title="Modify Date"></i>
                                    </div>
                                </td>
                                <td>{{ payment.datePaid | date: 'dd/MM/yyyy hh:mm' }}</td>
                                <td>{{ payment.paymentMethod | paymentMethod }}</td>
                                <td><p-checkbox disabled="disabled" [ngModel]="payment.done" [binary]="true" /></td>
                                <td><p-checkbox disabled="disabled" [ngModel]="payment.isProcessing" [binary]="true"
                                        [title]="payment.processingSince ?? ''" />
                                </td>
                                <td><p-checkbox disabled="disabled" [ngModel]="payment.hasError" [binary]="true"
                                        [title]="payment.errorMessage ?? ''" /></td>
                                <td><a target="_blank"
                                        *ngIf="payment.paymentIntentId != null && payment.paymentIntentId.length > 0"
                                        [href]="'https://dashboard.stripe.com/payments/' + payment.paymentIntentId"
                                        class="ml-2 cursor-pointer" title="Stripe"><i class="pi pi-link"></i></a>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p>
            </p-panel>
        </p>

        <p class="mx-1 my-3">
            <p-panel header="Notifications">
                <p class="m-0">
                    <p-table [value]="deal.notificationJobs ?? []" [tableStyle]="{ 'min-width': '50rem' }">
                        <ng-template #header>
                            <tr>
                                <th>Notification Date</th>
                                <th>Type</th>
                                <th>To</th>
                                <th>Date Sent</th>
                                <th>Error Message</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-notification>
                            <tr>
                                <td>{{ notification.notificationDate | date: 'dd/MM/yyyy' }}</td>
                                <td>{{ notification.type | notificationType }}</td>
                                <td>{{ notification.to }}</td>
                                <td>{{ notification.dateSent | date: 'dd/MM/yyyy hh:mm' }}</td>
                                <td>{{ notification.errorMessage }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p>
            </p-panel>
        </p>
    </div>

    <div class="col-12 xl:col-4">
        @if (deal.subscriptionInfo != null) {
        <p class="mx-1 my-3">
            <p-panel>
                <ng-template #header>
                    <div class="flex items-center justify-content-between w-full">
                        <p class="m-0 font-bold">Subscription Info</p>
                        <p class="m-0">

                        </p>
                    </div>
                </ng-template>
                <div class="grid">
                    <div class="flex flex-column gap-2 col-12">
                        <label>i-host ID</label>
                        <input pInputText disabled [ngModel]="deal.subscriptionInfo.iHostId" />
                    </div>
                    <div class="flex flex-column gap-2 col-12">
                        <label>Start date </label>
                        <input pInputText disabled
                            [ngModel]="deal.subscriptionInfo.subscriptionStartDate | date: 'dd/MM/yyyy'" />
                    </div>
                    <div class="flex flex-column gap-2 col-12">
                        <label>End date</label>
                        <input pInputText disabled
                            [ngModel]="deal.subscriptionInfo.subscriptionEndDate | date: 'dd/MM/yyyy'" />
                    </div>
                </div>
            </p-panel>
        </p>
        }

        @if (deal.overdueInfo != null) {
        <p class="mx-1 my-3">
            <p-panel>
                <ng-template #header>
                    <div class="flex items-center justify-content-between w-full">
                        <p class="m-0 font-bold">Overdue Info</p>
                        <p class="m-0">
                            <p-tag severity="success" [value]="deal.overdueInfo.overdueCategory | overdueCategory" />
                        </p>
                    </div>
                </ng-template>
                <div class="grid">
                    <div class="flex flex-column gap-2 col-12 lg:col-6">
                        <label>Cancel Subscription</label>
                        <p-checkbox disabled="disabled" [ngModel]="deal.overdueInfo.cancelSubscriptionOnFailure"
                            [binary]="true" />
                    </div>
                    <div class="flex flex-column gap-2 col-12 lg:col-6">
                        <label>Cancel ThirdParty</label>
                        <p-checkbox disabled="disabled" [ngModel]="deal.overdueInfo.cancelThirdPartyOnFailure"
                            [binary]="true" />
                    </div>

                    <div class="flex flex-column gap-2 col-12">
                        <label>Category set at</label>
                        <input pInputText disabled
                            [ngModel]="deal.overdueInfo.overdueCategorySetAt | date: 'dd/MM/yyyy hh:mm'" />
                    </div>

                    <div class="flex flex-column gap-2 col-12">
                        <label>Email sent At</label>
                        <input pInputText disabled
                            [ngModel]="deal.overdueInfo.stopAccessEmailDate | date: 'dd/MM/yyyy hh:mm'" />
                    </div>

                    <div class="flex flex-column gap-2 col-12">
                        <label>Access will stop at</label>
                        <input pInputText disabled
                            [ngModel]="deal.overdueInfo.stopAccessCutoffDate | date: 'dd/MM/yyyy hh:mm'" />
                    </div>

                    <div class="flex flex-column gap-2 col-12"
                        *ngIf="deal.overdueInfo.stopedAccessDueToOverude != null">
                        <label>Stoped access at</label>
                        <input pInputText disabled
                            [ngModel]="deal.overdueInfo.stopedAccessDueToOverude | date: 'dd/MM/yyyy hh:mm'" />
                    </div>
                </div>
            </p-panel>
        </p>
        }

        @if (hasCancelInfo) {
        <p class="mx-1 my-3">
            <p-panel header="Cancellation Data">
                <div class="grid">
                    <div class="flex flex-column gap-2 col-12" *ngIf="deal.cancelInfo.CanceledOn != null">
                        <label>Canceled On</label>
                        <input pInputText disabled [ngModel]="deal.cancelInfo.CanceledOn | date: 'dd/MM/yyyy hh:mm'" />
                    </div>
                    <div class="flex flex-column gap-2 col-12" *ngIf="deal.cancelInfo.CanceledOn != null">
                        <label>Reason</label>
                        <input pInputText disabled [ngModel]="deal.cancelInfo.CancelationReason" />
                    </div>
                </div>
            </p-panel>
        </p>
        }
    </div>
</div>
}

<p-dialog header="Modify Payment Data" [modal]="true" [(visible)]="modifyPaymentModalVisible"
    [style]="{ width: '500px' }">
    <div class="flex flex-column gap-4 mt-4 mb-8">
        <div class="p-field flex flex-column gap-2">
            <label>Date</label>
            <p-datepicker [(ngModel)]="updatedDate" appendTo="body" dateFormat="dd/mm/yy" />
        </div>

        <div class="p-field flex flex-column gap-2">
            <label>Modification Comments</label>
            <textarea type="text" pInputText id="updateComments" [(ngModel)]="updateComments" rows="4" fluid></textarea>
        </div>
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" severity="secondary" (click)="modifyPaymentModalVisible = false" />
        <p-button label="Modify" (click)="submitModification()" />
    </div>
</p-dialog>